<template>
  <a-modal
    :visible="visible"
    :title="$t('create')"
    :ok-text="$t('ok')"
    :cancel-text="$t('close')"
    :width="1000"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="back" :loading="loading" @click="handleCancel">
        {{ $t('cancel')}}
      </a-button>
      <a-button :loading="loading" type="danger" @click="() => reset()">
        {{ $t('page_calendar_reset')}}
      </a-button>
      <a-button :loading="loading" type="primary" @click="() => handleOk()">
        {{ $t('save')}}
      </a-button>
    </template>
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row :gutter="24">
        <a-col
          :span="12"
        >
          <a-form-item :label="$t('page_plan_maintenance_maintenance_items_code')">
            <a-input
              v-decorator="[
                'code',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('page_material_warehousing_p_input'),
                    },
                  ],
                },
              ]"
              :maxLength="32"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_maintenance_items_code')"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="12"
        >
          <a-form-item :label="$t('page_plan_maintenance_program')">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('page_material_warehousing_p_input'),
                    },
                  ],
                },
              ]"
              :maxLength="64"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_program')"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="12"
        >
          <a-form-item :label="$t('page_plan_maintenance_period')">
            <a-input-number
              :min="1"
              :max="99999"
              style="width:100%"
              v-decorator="[
                'intervalTime',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('page_material_warehousing_p_input'),
                    },
                  ],
                },]"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_period')"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="12"
        >
          <a-form-item :label="$t('page_plan_maintenance_warning_days')">
            <a-input-number
              :min="0"
              :max="99999"
              style="width:100%"
              v-decorator="['preWarningDays']"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_warning_days')"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col
          :span="24"
        >
          <a-form-item :label="$t('remark')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-textarea
              :maxLength="100"
              v-decorator="['remark']"
              :placeholder="$t('common_please_input') + $t('remark')"
              :rows="5"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <ml-table bordered :data-source="dataSource" :columns="columns">
      <template slot="actions" slot-scope="text, record">
        <a-popconfirm
          v-if="dataSource.length"
          :title="$t('page_mdc_setting_sure_delete')"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">{{ $t('delete')}}</a>
        </a-popconfirm>
      </template>
      <template slot="code" slot-scope="text, record">
        <a-select :value="text" @change="e => handleChange(e, record.key)" style="width: 100%;">
          <template v-for="(item,index) in maintainItemList">
            <a-select-option :value="item.code" :key="index">
              {{ item.code }}
            </a-select-option>
          </template>
        </a-select>
      </template>
    </ml-table>
    <a-button type="primary" style="width: 100%;margin-top: 8px;" @click="handleAdd()">{{$t('page_plan_maintenance_add_program')}}</a-button>
  </a-modal>
</template>

<script>
import { MaintainItemServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { MaintainProjectServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
const mpjsp = new MaintainProjectServiceProxy()
const misp = new MaintainItemServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'actions'}
  },
  {
    title: 'page_plan_maintenance_maintenance_item_code',
    dataIndex: 'code',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'code'}
  },
  {
    title: 'page_plan_maintenance_items',
    dataIndex: 'name',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_maintenance_requirements',
    dataIndex: 'requirement',
    ellipsis: true,
    width: 150
  },
  {
    title: 'remark',
    dataIndex: 'remark',
    ellipsis: true,
    width: 150
  }
]
export default {
  data(){
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: this.$form.createForm(this),
      dataSource: [],
      count: 0,
      maintainItemList: [],
      loading: false
    }
  },
  props:{
    visible:{
      type:Boolean,
      default: false
    },
    deviceId:{
      type: String,
      default: ""
    },
    selectDevice:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    getList(){
      misp.queryMaintainItemListCanRelate().then(res =>{
        this.maintainItemList = res
      })
    },
    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.key !== key);
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        code: "",
        name: "",
        requirement: "",
        remark: ""
      };
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
    handleChange(value, key) {
      const has = this.dataSource.find(res => res.code === value)
      if(has != undefined){
        this.$message.warning(this.$t('page_plan_maintenance_not_choose_same'))
        return
      }
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      const data = this.maintainItemList.find(res => res.code === value)
      if (target && data) {
        target['id'] = data.id;
        target['code'] = value;
        target['name'] = data.name;
        target['requirement'] = data.requirement;
        target['remark'] = data.remark;
        this.dataSource = newData;
      }
    },
    reset(){
      this.form.resetFields()
      this.dataSource = []
      this.count = 0
    },
    handleCancel(){
      this.reset()
      this.$emit('close')
    },
    handleOk(){
      this.form.validateFields((err,values) => {
        if(!err){
          Object.keys(values).forEach(key => {
            const item = values[key]
            values[key] = (values[key] && (typeof item) == 'string') ? values[key].replace(/\s*/g,"") : values[key]
          });
          const maintainItemList = JSON.parse(JSON.stringify(this.dataSource))
          const list = []
          const canSave = true
          maintainItemList.forEach(res => {
            if(res.id) {
              const value = {
                itemId: res.id,
                projectId: ""
              }
              list.push(value)
            }
          });
          if(list.length < 1){
            this.$message.warning(this.$t('page_plan_maintenance_please_add_program'))
            return
          }
          if(list && list.length > 0){
            values.maintainItemList = list
            values.deviceTypeId = this.deviceId
            values.deviceTypeName = this.selectDevice.name
            this.loading = true
            mpjsp.createMaintainProject(values).then(() =>{
              this.$message.success(this.$t('create_success'))
              this.reset()
              this.loading = false
              this.$emit('reload')
            }).catch(() => {this.loading = false})
          }
        }
      })
    }
  }
}
</script>

<style>

</style>
